import type { ReactNode } from 'react';
import Image from 'next/image';
import IconLeftStar from '../images/icon-star-left.png';
import IconRightStar from '../images/icon-star-right.png';

export interface StarTitleProps {
  text: ReactNode;
  className?: string;
  textClassName?: string;
}

export default function StarTitle({ text, className, textClassName }: StarTitleProps) {
  return (
    <div className={`flex items-center ${className || ''}`}>
      <Image
        src={IconLeftStar.src}
        alt="star-left"
        width={11}
        height={19}
        style={{ aspectRatio: '44 / 76' }}
      />
      <div className={`mx-1 bg-[linear-gradient(90deg,_#BFE1FD_0%,_#B8CDEF_54.33%,_#A2BCE2_100%)] bg-clip-text text-transparent text-base font-bold leading-5 ${textClassName}`}>
        {text}
      </div>
      <Image
        src={IconRightStar.src}
        alt="star-right"
        width={5}
        height={19}
        style={{ aspectRatio: '20 / 76' }}
      />
    </div>
  );
}

